export default "__VITE_ASSET__GpMTzCu4__"